import { inject } from 'mobx-react';
import * as React from 'react';

import { ShortlistToggleProvider } from '@shared-ui/trip-planning-travelpulse';

import { UIPageStore } from 'src/common/stores/ui-page-store';

import { Level, liveAnnounce } from 'uitk-react-utils';

export const ShortlistProvider: React.FC<{ uiPage?: UIPageStore }> = inject('uiPage')(({ children, uiPage }) => {
  const dispatchHandler = ({ message }: { message: string }) => {
    uiPage?.showNotification(message);
    liveAnnounce(message, Level.POLITE);
  };

  return <ShortlistToggleProvider dispatchHandler={dispatchHandler}>{children}</ShortlistToggleProvider>;
});
